
export default {
	name: "News",
	props: {
		imageUrl: {
			type: String,
			default: ""
		},
		title: {
			type: String,
			default: ""
		}
	}
};
